import App from "./App.svelte";
import "./styles/site.css";

const target = document.getElementById("app");
if (!target) {
  throw new Error("missing #app");
}

const app = new App({ target });

export default app;
